import styled, { css } from "styled-components";
import { border, color, onHover, units, visuallyHidden } from "@m/alchemy-theme";
import { NakedButton } from "../../naked-button/NakedButton";
import { Label as FieldLabel } from "../field-label/FieldLabel.styled";
import { Wrapper as FieldWrapper } from "../field/Field.styled";
import { FocusList } from "../../utilities/focus-list/FocusList";
import { Message as FieldStatus } from "../field-status/FieldStatus.styled";
import { ColorFieldColorSwatch, ColorFieldColorSwatchWrapper } from "../color-field/ColorField.styled";
export const ColorPicker = styled.div `
  display: flex;
  flex-direction: column;
  max-width: 250px;
`;
export const ColorPickerContent = styled.div `
  display: flex;
  flex-direction: column;
  max-width: ${units(30)};
  width: ${units(29.5)};
  overflow-x: hidden;

  .react-colorful {
    width: 100%;
    padding-bottom: 25px;
  }

  .react-colorful__hue,
  .react-colorful__alpha {
    border-radius: 8px;
    width: 125px;
    height: 12px;
    position: absolute;
    right: 20px;
    bottom: 4px;
  }

  .react-colorful__alpha {
    bottom: -20px;
  }

  .react-colorful__hue-pointer,
  .react-colorful__alpha-pointer {
    width: 16px;
    height: 16px;
  }

  .react-colorful__saturation-pointer {
    height: 16px;
    width: 16px;
  }
`;
export const ColorPickerBody = styled.div `
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: ${units(1)};
`;
export const ColorPickerFocusList = styled(FocusList) `
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;

  /* ie11 */
  max-width: ${units(30)};
  width: ${units(29.5)};

  button {
    margin: ${units(0.5)} ${units(0.5)} 0 0;
  }
`;
export const ColorPickerInputRow = styled.div `
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: ${units(1)} ${units(1)} 0 ${units(1)};
  min-height: 85px;

  ${({ hasColorPalette }) => hasColorPalette &&
    css `
      border-bottom: ${border()};
      padding-bottom: ${units(1)};
    `};

  ${({ hasColorPicker }) => hasColorPicker &&
    css `
      ${ColorFieldColorSwatch},
      ${ColorFieldColorSwatchWrapper} {
        display: none;
      }
    `};

  ${FieldStatus},
  ${FieldLabel} {
    ${visuallyHidden()};
  }

  > div:first-child {
    flex-grow: 1;
  }
`;
export const ColorPickerInputRowColor = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
`;
export const ColorPickerFooter = styled.div `
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: ${units(1.5)} ${units(1)} ${units(1)} ${units(1)};

  :first-child {
    margin-right: ${units(1)};
  }
`;
export const ColorPickerRow = styled.div `
  width: 100%;
  position: relative;
  height: ${units(6.5)};
  margin-top: -25px; /* needs to go up into react colorful area that has absolute positioned items */
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
export const ColorPickerSwatch = styled.div `
  position: relative;
  width: ${units(4.5)};
  height: ${units(4.5)};
  padding: 0; /* ios safari */
  border-radius: 50%;
  background-color: ${({ backgroundColor }) => backgroundColor};
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);
`;
export const ColorPickerSwatchTransparentLine = styled.div `
  display: block;
  position: absolute;
  left: 0;
  top: 50%;
  background-color: ${color("base", { palette: "interactiveDestructive" })};
  width: ${units(4.5)};
  height: 1px;
  transform: rotate(-45deg);
`;
export const ColorPickerColor = styled(NakedButton) `
  position: relative;
  min-width: ${units(2.5)};
  width: ${units(2.5)};
  height: ${units(2.5)};
  padding: 0; /* ios safari */
  border-radius: 50%;
  background-color: ${({ backgroundColor }) => backgroundColor};
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);

  svg {
    width: ${units(2.5)};
    height: ${units(2.5)};
    position: absolute;
    color: ${color("base", { palette: "interactiveDestructive" })};
  }

  ::after {
    content: "";
    width: ${units(3.25)};
    height: ${units(3.25)};
    position: absolute;
    left: -3px;
    top: -3px;
    border-radius: 50%;
    border: 1px solid
      ${({ isSelected }) => (isSelected ? color("base", { palette: "interactiveConstructive" }) : "transparent")};
  }

  ${onHover(css `
    ::after {
      content: "";
      width: ${units(3.25)};
      height: ${units(3.25)};
      position: absolute;
      left: -3px;
      top: -3px;
      border-radius: 50%;
      border: 2px solid ${color("base", { palette: "interactiveConstructive" })};
    }
  `)}
`;
export const ColorPickerColorTransparentLine = styled.span `
  display: block;
  position: absolute;
  left: 0;
  top: 50%;
  background-color: ${color("base", { palette: "interactiveDestructive" })};
  width: ${units(2.5)};
  height: 1px;
  transform: rotate(-45deg);
`;
export const ColorPickerVisuallyHidden = styled.span `
  ${visuallyHidden()};
`;
export const ColorPickerTypeControl = styled.div `
  align-self: start;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: ${units(1.5)};
    height: ${units(3)};
    color: ${color("base")};

    svg {
      transform: scale(1.2);
    }
  }
`;
export const ColorPickerSelectWrapper = styled.div `
  margin: ${units(1.5)} 0;
`;
export const ColorPickerEyeDropper = styled.div `
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${units(4)};
  height: ${units(4)};
  margin: ${units(1.5)} 0 0 ${units(1)};

  svg {
    ${onHover(css `
      cursor: pointer;
    `)}
  }

  ${FieldWrapper} {
    width: ${units(3.5)};
    height: ${units(3.5)};
  }
  ${FieldLabel} {
    color: ${({ eyeDropperColor }) => (eyeDropperColor ? eyeDropperColor : "initial")};
  }

  input {
    border: 0;
    padding: 0;
    border-radius: ${units(5)};
    width: ${units(4)};
    height: ${units(4)};
    position: absolute;
    top: 0;
    left: -1px;
    visibility: hidden;
  }
`;
